import React, { useEffect, useState, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import 'react-tagsinput/react-tagsinput.css';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
// import ReactHtmlParser from 'react-html-parser';
import { message, Spin, Input, AutoComplete, Drawer, Space, Modal, Button as Buttons } from 'antd'; // , Popover, Checkbox, 
import propTypes from 'prop-types';
import juice from 'juice';
import { MailBox2 } from './email-style';
import CustomHtmlParser from './CustomHtmlParser'
import TinyMCEEditor from "../EditorFolder/TinyMCE"
import { TopToolBoxClone3 } from '../../styled';
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService'
import {
  FetchAllRecentMails1, AIDefatMessage, updateDraftEmail,
  saveDraft, sendTemplateMail, selectEmailTemplate,
  sendDraftEmail, FetchDetailspage,
  deleteDraft,
} from '../../../Api/Services/EmailApiSevices';
import TemplateSelect from '../Popup/TemplateSelectPopup'
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import AiDraftConfirmPopup from '../Popup/AiDraftConfirmPopup'
import { Button } from '../../../components/buttons/buttons';
import { AiIcon, InsertTempIcon } from '../../../components/Icons/Icons';

function Compose({ close, mailOpen, entity, entityName, toId, entityUId, setNaCTrigger, Comefrom, setTemplateIDSS, searchText, templateIDSS, DeleteDraftForever, SendFunction, detailsPage, setDetailsData, DraftFunction, replyToPopup, forwardformatss, AccountId, CallBackTrigger, isCancel }) { // TrashFunction, MovetoTrash, dbMailId, setDbMailId,
  const { emailapiValues } = useSelector((state) => state.EmailData);
  const localData = useSelector((state) => state.localRedux);
  const companyProfile = localData.company
  const ProfileData = localData.profile
  const profile = ProfileData;
  const loadingRef = useRef(false);
  const [doubleClick, setDoubleClick] = useState(false)
  const [doubleClick1, setDoubleClick1] = useState(false)
  const [doubleClick2, setDoubleClick2] = useState(false)
  const [openTemplate, setOpenTemplate] = useState(false)
  const [popupMessage, setPopupMessage] = useState(false)
  const [mailSaveId, setMailSaveId] = useState()
  const [typeOfPge, setTypeOfPge] = useState()
  const [entityId, setEntityId] = useState()
  const [forwardformat, setForwardformat] = useState()
  const [page, setPage] = useState()
  const [state, setState] = useState({
    size: 'small',
    tags: [],
  });
  const [disabled, setDisbled] = useState(false)
  // const [replayTo, setReplayTo] = useState()
  const [CcOpen, setCcOpen] = useState(false)
  const [CcData, setCcData] = useState([])
  const [BccOpen, setBccOpen] = useState(false)
  const [BccData, setBccData] = useState([])
  const [linkType, setLinkType] = useState('Contacts_Leads,Accounts');
  const [subject, setSubject] = useState("")
  const [content, setContent] = useState("");
  const [templateId, setTemplateId] = useState({ id: null, key: 0 })
  const [templateID, setTemplateID] = useState()
  const [files, setFiles] = useState([]);
  const [composeSize, setComposeSize] = useState(600)
  const [aiCompose, setAiCompose] = useState(false)
  const [aiContent, setAiContent] = useState()
  const [showAiDraftConfirm, setShowAiDraftConfirm] = useState(false)

  const edit = true;
  const [participantData, setParticipantData] = useState([])
  const [participantData2, setParticipantData2] = useState([])
  // To
  const [toInputValue, setToInputValue] = useState('');
  const [toOptions, setToOptions] = useState([]);
  const [toSelectedItems, setToSelectedItems] = useState([]);
  // CC
  const [ccInputValue, setCcInputValue] = useState('');
  const [ccOptions, setCcOptions] = useState([]);
  const [ccSelectedItems, setCcSelectedItems] = useState([]);
  // Bcc
  const [bccInputValue, setBccInputValue] = useState('');
  const [bccOptions, setBccOptions] = useState([]);
  const [bccSelectedItems, setBccSelectedItems] = useState([]);
  // const [templateData, setTemplateData] = useState(null)
  const toggleSize = (value) => {
    setComposeSize(value)
  }
  // const convertToOriginalHtml = async (plainText) => {
  //   const lines = plainText.split('\n');
  //   const htmlContent = [];
  //   let lastWasEmpty = false;
  //   lines.forEach(line => {
  //     if (line.trim() === "" || line.trim() === " ") {
  //       if (!lastWasEmpty) {
  //         htmlContent.push("<p><br></p>");
  //         lastWasEmpty = true;
  //       }
  //     } else {
  //       htmlContent.push(`<p>${line}</p>`);
  //       lastWasEmpty = false;
  //     }
  //   });
  //   return htmlContent.join('');
  // };
  const OpenTemplates = () => {
    setOpenTemplate(true)
  }
  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = days[date.getUTCDay()];
    const month = months[date.getUTCMonth()];
    const dayOfMonth = date.getUTCDate();
    const year = date.getUTCFullYear();
    const hour = date.getUTCHours();
    const minute = date.getUTCMinutes();
    const formattedDate = `${day}, ${month} ${dayOfMonth} ${year} ${hour}:${minute < 10 ? `0${minute}` : minute}`;
    return formattedDate;
  };
  const setTemplateContant = async (value) => {
    setSubject(value?.templateSubject)
    setContent(value?.content);
  }
  async function getcontent() {
    try {
      const data = await selectEmailTemplate(templateId.id, entityName, entityId)
      setTemplateContant(data);
      setTemplateId({ id: null, key: 0 })
    } catch (error) {
      setTemplateId({ id: null, key: 0 })
      message.error(error);
    }
  }
  useEffect(() => {
    if (templateIDSS) {
      setMailSaveId(templateIDSS)
    }
  }, [templateIDSS])
  useEffect(() => {
    if (mailOpen) {
      if (templateId.id) {
        getcontent()
        // GetTemplateData()
      }
    }
  }, [templateId, entityName, mailOpen])
  //  <div style="margin: 20px 0; font-family: 'Noto Sans', sans-serif;">
  useEffect(() => {
    if (mailOpen) {
      setTypeOfPge(replyToPopup)
      if (forwardformatss) {
        setForwardformat(forwardformatss)
        if (replyToPopup === "Forward") {
          const { date, from, to, cc, subject, body, attachment } = forwardformatss;
          // const formattedBody = body.replace(/\n/g, '<br />');
          // const bodyWithLinks = convertUrlsToLinks(formattedBody);
          const fromAddress = from?.address || from.email
          const toAddress = to?.map((item) => (item.address || item.email)).join(", ")
          const ccAddress = cc?.map((item) => (item.address || item.email)).join(", ")
          const inlinedHtml = juice(body);
          const finalHtml = inlinedHtml
            .replace(/<!DOCTYPE html>/, '')
            .replace(/<html[^>]*>/, '')
            .replace(/<\/html>/, '')
            .replace(/<head>.*<\/head>/s, '')
            .replace(/<body[^>]*>/, match => {
              const bodyStyleMatch = match.match(/style="([^"]*)"/);
              return `<div style="${bodyStyleMatch ? bodyStyleMatch[1] : ''}">`;
            })
            .replace('</body>', '</div>')
            .trim();
          const emailContent = `
  <div></div>
  <div contenteditable="false"id="ForwardContent">
    <hr style="border: 1px solid #ccc; margin: 20px 0;" />
    <div style="margin: 20px 0; font-family:'Noto Sans', sans-serif;">
      <div>============ Forwarded message ============</div>
      <div><strong>From:</strong> ${fromAddress}</div>
      <div><strong>To:</strong> ${toAddress}</div>
      <div><strong>Cc:</strong> ${ccAddress}</div>
      <div><strong>Date:</strong> ${date}</div>
      <div><strong>Subject:</strong> ${subject}</div>
      <div>============ Forwarded message ============</div>
    </div>
    ${finalHtml}
  </div>
`;
          setContent(emailContent)
          setSubject(`Fwd: ${subject}`)
          setFiles(attachment.filter((attachment) => attachment.contentDisposition === "attachment"));
        }
        if (replyToPopup === "DraftDetail") {
          if (forwardformatss) {
            if (forwardformatss?.cc?.length > 0) { setCcOpen(true) }
            else { setCcOpen(false) }
            if (forwardformatss?.bcc.length > 0) { setBccOpen(true) }
            else { setBccOpen(false) }
            setLinkType("Contacts_Leads,Accounts")
            setSubject(forwardformatss?.subject)
            setContent(forwardformatss?.body);
            setFiles(forwardformatss?.attachments.filter((attachment) => attachment.contentDisposition === "attachment"));
          }
        }
        if (replyToPopup === "Reply To" || replyToPopup === "Reply All") {
          const { date, from, body, subject } = forwardformatss;
          const inlinedHtml = juice(body);
          const finalHtml = inlinedHtml
            .replace(/<!DOCTYPE html>/, '')
            .replace(/<html[^>]*>/, '')
            .replace(/<\/html>/, '')
            .replace(/<head>.*<\/head>/s, '')
            .replace(/<body[^>]*>/, match => {
              const bodyStyleMatch = match.match(/style="([^"]*)"/);
              return `<div style="${bodyStyleMatch ? bodyStyleMatch[1] : ''}">`;
            })
            .replace('</body>', '</div>')
            .trim();
          const emailContent = `
        <div> </div>
        <div contenteditable="false" id="ReplyContent">
        <hr style="border: 1px solid #ccc; margin: 20px 0;" />
        <div class="quoted">
        <div>---- On ${formatDate(date)}, <strong>${from?.address || from.email}</strong> wrote ----</div>
        <blockquote>
        ${finalHtml}
        </blockquote>
        </div> 
        </div>
      `;
          setContent(emailContent)
          const formattedSubject = subject?.trim().toLowerCase().startsWith("re:")
            ? subject
            : `Re: ${subject}`;

          setSubject(formattedSubject);
        }
      }
    }
  }, [replyToPopup, forwardformatss, mailOpen])
  function normalizeEmailData(input) {
    const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
    const parseEmail = (emailString) => {
      emailString = cleanString(emailString);
      const match = emailString.match(/(.*)<(.+)>/);
      if (match) {
        return {
          name: cleanString(match[1]),
          address: match[2].trim(),
        };
      }
      return {
        name: "",
        address: emailString,
      };
    };
    const normalizeField = (field) => {
      if (!field) return [];
      return field.split(",").map((item) => parseEmail(item.trim()));
    };
    const BodywithLinks = (data) => {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      const formattedMessage = data.replace(urlPattern, (url) => {
        const escapedUrl = encodeURIComponent(url);
        return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
      });
      return formattedMessage.replace(/\n/g, '<br />');
    };
    const formattedFrom = parseEmail(input.from || "");
    const formattedTo = normalizeField(input.to || "");
    const formattedCc = normalizeField(input.cc || "");
    const formattedBcc = normalizeField(input.bcc || "");
    let bodyText = "";
    if (emailapiValues?.emailType === "Outlook") {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    else if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
      bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
    }
    return {
      ...input,
      subject: input ? input.subject !== "" && input.subject ? input.subject : "(No Subject)" : "(No Subject)",
      from: formattedFrom,
      to: formattedTo,
      cc: formattedCc,
      bcc: formattedBcc,
      body: bodyText,
    };
  }
  function normalizeEmailDataforOutlook(input) {
    let bodyText = "";
    if (emailapiValues?.emailType === 'Outlook') {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    return {
      ...input,
      body: bodyText,
    };
  }
  async function getDetailsApi(detailsPage, detailsId) {
    setForwardformat()
    try {
      const data = await FetchDetailspage(detailsId, detailsPage)
      if (data.code === 200) {
        let modifiedData;
        const originalData = data.data;
        if (emailapiValues?.emailType === 'Outlook') {
          modifiedData = normalizeEmailDataforOutlook(originalData);
        } else if (emailapiValues?.emailType === 'Google' || emailapiValues?.emailType === 'Zoho' || emailapiValues?.emailType === "Other Email") {
          modifiedData = normalizeEmailData(originalData);
        };
        setForwardformat(modifiedData)
        setTemplateId({ id: null, key: 0 })
      }
      else {
        setDisbled(false)
        setForwardformat()
        if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
          // try {
          //   await DelteMailFromDB(dbMailId)
          //   setDbMailId()
          // } catch (error) {
          //   message.error(error);
          // }
          DraftFunction("Drafts", 1, searchText)
          if (isCancel === "Yes") { setTemplateIDSS() }
        }
        close()
        setPopupMessage(false)
        setState({
          size: 'small',
          tags: [],
        });
        setMailSaveId()
        setToInputValue('')
        setToSelectedItems([])
        setCcInputValue('')
        setBccInputValue('')
        setBccOptions([])
        setBccSelectedItems([])
        setCcSelectedItems([])
        setCcOptions([])
        setToOptions([])
        setCcOpen(false)
        setCcData([])
        setBccOpen(false)
        setBccData([])
        setLinkType("Contacts_Leads,Accounts")
        setTemplateId({ id: null, key: 0 })
        setSubject("")
        setContent("");
        message.error("The email you’re trying to open has been deleted or no longer exists. It may have been moved, archived, or permanently removed")
      }
    }
    catch (error) {
      setDisbled(false)
      setForwardformat()
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        // try {
        //   await DelteMailFromDB(dbMailId)
        //   setDbMailId()
        // } catch (error) {
        //   message.error(error);
        // }
        DraftFunction("Drafts", 1, searchText)
        if (isCancel === "Yes") { setTemplateIDSS() }
      }
      close()
      setPopupMessage(false)
      setState({
        size: 'small',
        tags: [],
      });
      setMailSaveId()
      setToInputValue('')
      setToSelectedItems([])
      setCcInputValue('')
      setBccInputValue('')
      setBccOptions([])
      setBccSelectedItems([])
      setCcSelectedItems([])
      setCcOptions([])
      setToOptions([])
      setCcOpen(false)
      setCcData([])
      setBccOpen(false)
      setBccData([])
      setLinkType("Contacts_Leads,Accounts")
      setTemplateId({ id: null, key: 0 })
      setSubject("")
      setContent("");
      message.error("The email you’re trying to open has been deleted or no longer exists. It may have been moved, archived, or permanently removed")
    }
  }
  const onEmailSend = async (id) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick(true)
    // const plainTextContent = await convertToPlainText(content);
    const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
    setDisbled(true)
    const payload = {
      to: state.tags,
      content: formattedHtmlContent,
      subject: subject && subject !== "" ? subject : "(No Subject)",
      cc: CcData,
      bcc: BccData,
      attachments: files,

    }
    let hideMessage;
    if (id) {
      hideMessage = message.loading("Sending Email", 0);
      try {
        const response = await sendDraftEmail(id, linkType, payload)
        if (response.status === 201) {
          if (entity === "EntityPages") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  CallBackTrigger("Callback");
                })
                .catch(err => {
                  CallBackTrigger("Callback");
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          hideMessage();
          setDisbled(false)
          if (Comefrom === "Entity" || Comefrom === "Entitys") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                })
                .catch(err => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            // try {
            //   await DelteMailFromDB(dbMailId)
            //   setDbMailId()
            // } catch (error) {
            //   message.error(error);
            // }
            DraftFunction("Drafts", 1, searchText)
            setTimeout(() => {
              SendFunction("Sent", 1, searchText)
            }, 3000);
            if (isCancel === "Yes") { setTemplateIDSS() }
          }
          close()
          setState({
            size: 'small',
            tags: [],
          });
          setMailSaveId()
          setToInputValue('')
          setToSelectedItems([])
          setCcInputValue('')
          setBccInputValue('')
          setBccOptions([])
          setBccSelectedItems([])
          setCcSelectedItems([])
          setCcOptions([])
          setToOptions([])
          setCcOpen(false)
          setCcData([])
          setBccOpen(false)
          setBccData([])
          setLinkType("Contacts_Leads,Accounts")
          setTemplateId({ id: null, key: 0 })
          setSubject("")
          setContent("");
          message.success("Email sent")
          loadingRef.current = false;
          setDoubleClick(false)
        }
      }
      catch (error) {
        loadingRef.current = false;
        setDoubleClick(false)
        hideMessage();
        setDisbled(false)
        message.error(error);
      }
    } else {
      hideMessage = message.loading("Sending Email", 0);
      try {
        const linksend = entityName === "Deals" ? `Deals?linkTypeId=${entityUId}` : linkType
        const response = await sendTemplateMail(linksend, payload)
        if (entity === "EntityPages") {
          setTimeout(() => {
            FetchAllRecentMails1("Sent")
              .then(() => {
                CallBackTrigger("Callback");
              })
              .catch(err => {
                CallBackTrigger("Callback");
                console.error("Error fetching recent mails:", err);
              });
          }, 2000);
        }
        if (response.status === 201) {
          hideMessage();
          setDisbled(false)
          if (Comefrom === "Entity" || Comefrom === "Entitys") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                })
                .catch(err => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            setTimeout(() => {
              SendFunction("Sent", 1, searchText)
            }, 3000);
            if (isCancel === "Yes") { setTemplateIDSS() }
          }
          close()
          setState({
            size: 'small',
            tags: [],
          });
          setMailSaveId()
          setToInputValue('')
          setToSelectedItems([])
          setCcInputValue('')
          setBccInputValue('')
          setBccOptions([])
          setBccSelectedItems([])
          setCcSelectedItems([])
          setCcOptions([])
          setToOptions([])
          setCcOpen(false)
          setCcData([])
          setBccOpen(false)
          setBccData([])
          setLinkType("Contacts_Leads,Accounts")
          setTemplateId({ id: null, key: 0 })
          setSubject("")
          setContent("");
          message.success("Email sent")
        }
        loadingRef.current = false;
        setDoubleClick(false)
      }
      catch (error) {
        loadingRef.current = false;
        setDoubleClick(false)
        hideMessage();
        setDisbled(false)
        message.error(error);
      }
    }
  }
  const onDeleteSend = async (id) => {
    if (id) {
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        setDisbled(true)
        DeleteDraftForever([{ mailId: id }])
        if (entity === "MailPage") {
          setDetailsData()
          setForwardformat()
          if (isCancel === "Yes") { setTemplateIDSS() }
        }
        setState({
          size: 'small',
          tags: [],
        });
        setMailSaveId()
        setToInputValue('')
        setToSelectedItems([])
        setCcInputValue('')
        setBccInputValue('')
        setBccOptions([])
        setBccSelectedItems([])
        setCcSelectedItems([])
        setCcOptions([])
        setToOptions([])
        setCcOpen(false)
        setCcData([])
        setBccOpen(false)
        setBccData([])
        setLinkType("Contacts_Leads,Accounts")
        setTemplateId({ id: null, key: 0 })
        setSubject("")
        setContent("");
        setPopupMessage(false)
        close()
        setDisbled(false)
      }
      else {
        let hideMessage;
        setDisbled(true)
        setMailSaveId()
        if (id) {
          const payload = {
            mailIds: [id]
          }
          hideMessage = message.loading("Deleting from Drafts...", 0);
          try {
            deleteDraft(payload)
            hideMessage();
            message.success('Draft(s) deleted forever');
            if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
              setDetailsData()
              setForwardformat()
              if (isCancel === "Yes") { setTemplateIDSS() }
            }
            setState({
              size: 'small',
              tags: [],
            });
            setMailSaveId()
            setToInputValue('')
            setToSelectedItems([])
            setCcInputValue('')
            setBccInputValue('')
            setBccOptions([])
            setBccSelectedItems([])
            setCcSelectedItems([])
            setCcOptions([])
            setToOptions([])
            setCcOpen(false)
            setCcData([])
            setBccOpen(false)
            setBccData([])
            setLinkType("Contacts_Leads,Accounts")
            setTemplateId({ id: null, key: 0 })
            setSubject("")
            setContent("");
            setPopupMessage(false)
            close()
            setDisbled(false)
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
      }
    }
    else {
      setMailSaveId()
      setDisbled(true)
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        setDetailsData()
        setForwardformat()
        if (isCancel === "Yes") { setTemplateIDSS() }
      }
      setState({
        size: 'small',
        tags: [],
      });
      setToInputValue('')
      setToSelectedItems([])
      setCcInputValue('')
      setBccInputValue('')
      setBccOptions([])
      setBccSelectedItems([])
      setCcSelectedItems([])
      setCcOptions([])
      setToOptions([])
      setCcOpen(false)
      setCcData([])
      setBccOpen(false)
      setBccData([])
      setLinkType("Contacts_Leads,Accounts")
      setTemplateId({ id: null, key: 0 })
      setSubject("")
      setContent("");
      setPopupMessage(false)
      close()
      setDisbled(false)
    }
  }
  const onDraftSend = async (id, type, action) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick1(true)
    if (toSelectedItems?.length) {
      const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
      setDisbled(true)
      const payload = {
        to: state.tags,
        content: formattedHtmlContent,
        subject: subject && subject !== "" ? subject : "(No Subject)",
        cc: CcData,
        bcc: BccData,
        attachments: files,
      }
      let hideMessage;
      if (id) {
        try {
          hideMessage = message.loading("Saving Draft Email", 0);
          const response = await updateDraftEmail(payload, id)
          if (response.status === 200) {
            hideMessage();
            if (type === "Save") {
              setDisbled(false)
              setForwardformat()
              setTypeOfPge("DraftDetail")
              if (action === "Close") {
                setMailSaveId()
                setDisbled(false)
                setForwardformat()
                if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                  if (isCancel === "Yes") { setTemplateIDSS() }
                  DraftFunction("Drafts", 1, searchText)
                }
                close()
                setPopupMessage(false)
                setState({
                  size: 'small',
                  tags: [],
                });
                setToInputValue('')
                setToSelectedItems([])
                setCcInputValue('')
                setBccInputValue('')
                setBccOptions([])
                setBccSelectedItems([])
                setCcSelectedItems([])
                setCcOptions([])
                setToOptions([])
                setCcOpen(false)
                setCcData([])
                setBccOpen(false)
                setBccData([])
                setLinkType("Contacts_Leads,Accounts")
                setTemplateId({ id: null, key: 0 })
                setSubject("")
                setContent("");
              }
              else if (action !== "Close") {
                if (emailapiValues?.emailType === "Google") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    // try {
                    //   await DelteMailFromDB(dbMailId)
                    //   setDbMailId()
                    // } catch (error) {
                    //   message.error(error);
                    // }
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.message.id) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.message.id)
                  getDetailsApi("Drafts", response.data.data.message.id)
                  setFiles([])
                }
                if (emailapiValues?.emailType === "Outlook") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    // try {
                    //   await DelteMailFromDB(dbMailId)
                    //   setDbMailId()
                    // } catch (error) {
                    //   message.error(error);
                    // }
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.mailId) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.mailId)
                  getDetailsApi("Drafts", response.data.mailId)
                  setFiles([])
                }
                if (emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
                  // setMailSaveId(response.data.draftId)
                  // getDetailsApi("Drafts", response.data.draftId)
                  setMailSaveId()
                  setDisbled(false)
                  setForwardformat()
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    // try {
                    //   await DelteMailFromDB(dbMailId)
                    //   setDbMailId()
                    // } catch (error) {
                    //   message.error(error);
                    // }
                    if (isCancel === "Yes") { setTemplateIDSS() }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  close()
                  setPopupMessage(false)
                  setState({
                    size: 'small',
                    tags: [],
                  });
                  setToInputValue('')
                  setToSelectedItems([])
                  setCcInputValue('')
                  setBccInputValue('')
                  setBccOptions([])
                  setBccSelectedItems([])
                  setCcSelectedItems([])
                  setCcOptions([])
                  setToOptions([])
                  setCcOpen(false)
                  setCcData([])
                  setBccOpen(false)
                  setBccData([])
                  setLinkType("Contacts_Leads,Accounts")
                  setTemplateId({ id: null, key: 0 })
                  setSubject("")
                  setContent("");
                }
              }
            }
            // else if (type === "SaveCheck") {
            //   setDisbled(false)
            //   setForwardformat()
            //   if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            //     // try {
            //     //   await DelteMailFromDB(dbMailId)
            //     //   setDbMailId()
            //     // } catch (error) {
            //     //   message.error(error);
            //     // }
            //     DraftFunction("Drafts", 1)
            //   }
            //   close()
            //   setPopupMessage(false)
            //   setState({
            //     size: 'small',
            //     tags: [],
            //   });
            //   setCcOpen(false)
            //   setCcData([])
            //   setBccOpen(false)
            //   setBccData([])
            //   setLinkType("Contacts_Leads,Accounts")
            //   setTemplateId(null)
            //   setSubject("")
            //   setContent("");
            // }
            message.success("Email draft saved")
            loadingRef.current = false;
            setDoubleClick1(false)
          }
        }
        catch (error) {
          loadingRef.current = false;
          setDoubleClick1(false)
          hideMessage();
          setDisbled(false)
          message.error(error);
        }
      } else {
        try {
          hideMessage = message.loading("Saving Draft Email", 0);
          const response = await saveDraft(payload)
          if (response.status === 201) {
            hideMessage();
            if (type === "Save") {
              setDisbled(false)
              setForwardformat()
              setTypeOfPge("DraftDetail")
              if (action === "Close") {
                setMailSaveId()
                setDisbled(false)
                setForwardformat()
                if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                  if (isCancel === "Yes") { setTemplateIDSS() }
                  DraftFunction("Drafts", 1, searchText)
                }
                close()
                setPopupMessage(false)
                setState({
                  size: 'small',
                  tags: [],
                });
                setToInputValue('')
                setToSelectedItems([])
                setCcInputValue('')
                setBccInputValue('')
                setBccOptions([])
                setBccSelectedItems([])
                setCcSelectedItems([])
                setCcOptions([])
                setToOptions([])
                setCcOpen(false)
                setCcData([])
                setBccOpen(false)
                setBccData([])
                setLinkType("Contacts_Leads,Accounts")
                setTemplateId({ id: null, key: 0 })
                setSubject("")
                setContent("");
              }
              else if (action !== "Close") {
                if (emailapiValues?.emailType === "Google") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.message.id) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.message.id)
                  getDetailsApi("Drafts", response.data.data.message.id)
                }
                if (emailapiValues?.emailType === "Outlook") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.mailId) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.mailId)
                  getDetailsApi("Drafts", response.data.data.mailId)
                }
                if (emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
                  // setMailSaveId(response.data.draftId)
                  // getDetailsApi("Drafts", response.data.draftId)
                  setMailSaveId()
                  setDisbled(false)
                  setForwardformat()
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS() }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  close()
                  setPopupMessage(false)
                  setState({
                    size: 'small',
                    tags: [],
                  });
                  setToInputValue('')
                  setToSelectedItems([])
                  setCcInputValue('')
                  setBccInputValue('')
                  setBccOptions([])
                  setBccSelectedItems([])
                  setCcSelectedItems([])
                  setCcOptions([])
                  setToOptions([])
                  setCcOpen(false)
                  setCcData([])
                  setBccOpen(false)
                  setBccData([])
                  setLinkType("Contacts_Leads,Accounts")
                  setTemplateId({ id: null, key: 0 })
                  setSubject("")
                  setContent("");
                }
              }
            }
            // else if (type === "SaveCheck") {
            //   setDisbled(false)
            //   setForwardformat()
            //   if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            //     DraftFunction("Drafts", 1)
            //   }
            //   close()
            //   setPopupMessage(false)
            //   setState({
            //     size: 'small',
            //     tags: [],
            //   });
            //   setCcOpen(false)
            //   setCcData([])
            //   setBccOpen(false)
            //   setBccData([])
            //   setLinkType("Contacts_Leads,Accounts")
            //   setTemplateId(null)
            //   setSubject("")
            //   setContent("");
            // }
            message.success("Email draft saved")
            loadingRef.current = false;
            setDoubleClick1(false)
          }
        }
        catch (error) {
          loadingRef.current = false;
          setDoubleClick1(false)
          hideMessage();
          setDisbled(false)
          message.error(error);
        }
      }
    }
    else {
      loadingRef.current = false;
      setDoubleClick1(false)
      message.error("Please add at least one recipient to save the draft");
    }
  }
  const onclose = (id, page) => {
    setPopupMessage(true)
    setTemplateID(id)
    setPage(page)
  }
  const onclose2 = () => {
    setPopupMessage(false)
    setTemplateID()
    setPage()
  }
  const OnCancel = () => {
    setTemplateID()
    setPage()
    setMailSaveId()
    setDisbled(false)
    setForwardformat()
    if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
      if (isCancel === "Yes") { setTemplateIDSS() }
      DraftFunction("Drafts", 1, searchText)
    }
    close()
    setPopupMessage(false)
    setState({
      size: 'small',
      tags: [],
    });
    setToInputValue('')
    setToSelectedItems([])
    setCcInputValue('')
    setBccInputValue('')
    setBccOptions([])
    setBccSelectedItems([])
    setCcSelectedItems([])
    setCcOptions([])
    setToOptions([])
    setCcOpen(false)
    setCcData([])
    setBccOpen(false)
    setBccData([])
    setLinkType("Contacts_Leads,Accounts")
    setTemplateId({ id: null, key: 0 })
    setSubject("")
    setContent("");
    // message.success("Email draft discarded")
  }
  // const [openQuery, setOpenQuery] = useState(false);
  const standardizeObjectFormat = (obj) => {
    const standardizedObj = {
      id: obj?.id || "",
      name: obj?.name || "",
      type: obj?.type || "",
      email: obj?.email || ""
    };
    return standardizedObj;
  };
  const processEmails = (emailString) => {
    // const emailRegex = /(?:<)?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:>)?/g;
    // const emailList = [...emailString.matchAll(emailRegex)].map(match => match[1].trim());
    const newUserList = emailString.map(replayids => {
      let userData = participantData.find(item => item.email === replayids);
      if (!userData) {
        userData = {
          id: "",
          name: replayids,
          type: "Others",
          email: replayids,
        };
      }
      else {
        userData = {
          id: userData.id,
          name: userData.name,
          type: userData.type,
          email: userData.email,
        };
      }
      return userData;
    });
    return newUserList;
  };
  const processEmails2 = (emailString) => {
    // const emailRegex = /(?:<)?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?:>)?/g;
    // const emailList = [...emailString.matchAll(emailRegex)].map(match => match[1].trim());
    const newUserList = emailString.map(replayids => {
      let userData = participantData2.find(item => item.email === replayids);
      if (!userData) {
        userData = {
          id: "",
          name: replayids,
          type: "Others",
          email: replayids,
        };
      }
      else {
        userData = {
          id: userData.id,
          name: userData.name,
          type: userData.type,
          email: userData.email,
        };
      }
      return userData;
    });
    return newUserList;
  };
  const Emailsarray = (emailString) => {
    const newUserList = emailString.map(replayids => {
      let userData = participantData.find(item => item.id === Number(replayids.id) && item.type === replayids.type);
      userData = {
        id: userData?.id,
        name: userData?.name,
        type: userData?.type,
        email: userData?.email,
      };
      return userData;
    });
    return newUserList;
  };
  async function getPartcipants() {
    try {
      const data = await FetchAllAttendeeList()
      setParticipantData2(data)
      let UserListData;
      if (entityName === "Leads") {
        UserListData = data.filter((item) => item.type === "Leads")
      }
      else if (entityName === "Contacts") {
        UserListData = data.filter((item) => item.type === "Contacts")
      }
      else if (entityName === "Deals" || entityName === "Accounts") {
        try {
          const response = await FetchContactByAccount(AccountId)
          UserListData = response.map(contact => ({
            id: contact.contacts_id,
            name: `${contact.first_name} ${contact.last_name}`,
            email: contact.email,
            type: 'Contacts'
          }));
        } catch (error) {
          message.error(error)
        }
      }
      else if (entityName === "Tasks") {
        UserListData = data.filter((item) => item.type === "User")
      }
      else {
        UserListData = data
      }
      setParticipantData(UserListData)
    } catch (error) {
      message.error(error)
    }
  };
  // const handleOpenQureyChange = (newOpen) => {
  //   setOpenQuery(newOpen);
  // };
  const handleCcOpen = () => {
    setCcOpen(true)
  }
  const handleBccOpen = () => {
    setBccOpen(true)
  }
  // const handleCheckboxChange = (field, isChecked) => {
  //   let updatedFields = linkType.split(',').filter(Boolean);
  //   if (isChecked) {
  //     updatedFields.push(field);
  //   } else {
  //     updatedFields = updatedFields.filter(item => item !== field);
  //   }
  //   setLinkType(updatedFields.join(','));
  // };
  const TohandleSearch = (value) => {
    setToInputValue(value);
    if (value) {
      const filteredOptions = participantData
        .filter(option =>
          option.name.toLowerCase().includes(value.toLowerCase())
          || option.email.toLowerCase().includes(value.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className='image_icon' style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
                {/* <p style={{ margin: 0 }}>{option.email !== null && option.email !== undefined && option.email !== "" ? `${option.email.substring(0, 10)}...` : option.email}({option.type})</p> */}
              </div>
              <div className='div_last'>
                {toSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      // const isValidEmail = /\S+@\S+\.\S+/.test(value);
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      // If valid email and not already in the filtered options, add it
      if (isValidEmail && !filteredOptions.some(option => option.data.email === value)) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setToOptions(filteredOptions);
    } else {
      setToOptions([]);
    }
  };
  const TohandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(toOptions[index].data);
    if (selectedItem) {
      const isSelected = toSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setToSelectedItems(toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setState({ ...state, tags: toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)) });
      } else {
        const newSelectedItems = [...toSelectedItems, selectedItem];
        setToSelectedItems(newSelectedItems);
        setState({ ...state, tags: newSelectedItems });
      }
      if (templateId?.id) {
        setSubject("")
        setTemplateId({ id: null, key: 0 })
        setContent("");
      }
      setToInputValue('');
      setToOptions([]);
    }
  };
  const TohandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setToSelectedItems(toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setState({ ...state, tags: toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)) });
  };
  const CchandleSearch = (value) => {
    setCcInputValue(value);
    if (value) {
      const filteredOptions = participantData2
        .filter(option =>
          option.name.toLowerCase().includes(value.toLowerCase())
          || option.email.toLowerCase().includes(value.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className='image_icon' style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
                {/* <p style={{ margin: 0 }}>{option.email !== null && option.email !== undefined && option.email !== "" ? `${option.email.substring(0, 10)}...` : option.email}({option.type})</p> */}
              </div>
              <div className='div_last'>
                {ccSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      // const isValidEmail = /\S+@\S+\.\S+/.test(value);
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      // If valid email and not already in the filtered options, add it
      if (isValidEmail && !filteredOptions.some(option => option.data.email === value)) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setCcOptions(filteredOptions);
    } else {
      setCcOptions([]);
    }
  };
  const CchandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(ccOptions[index].data);
    if (selectedItem) {
      const isSelected = ccSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setCcSelectedItems(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setCcData(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
      } else {
        const newSelectedItems = [...ccSelectedItems, selectedItem];
        setCcSelectedItems(newSelectedItems);
        setCcData(newSelectedItems);
      }
      setCcInputValue('');
      setCcOptions([]);
    }
  };
  const CchandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setCcSelectedItems(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setCcData(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
  };
  const setCcClose = () => {
    setCcOpen(false)
    setCcInputValue('');
    setCcOptions([]);
    setCcData([])
    setCcSelectedItems([])
  }
  const BcchandleSearch = (value) => {
    setBccInputValue(value);
    if (value) {
      const filteredOptions = participantData2
        .filter(option =>
          option.name.toLowerCase().includes(value.toLowerCase())
          || option.email.toLowerCase().includes(value.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className='image_icon' style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
                {/* <p style={{ margin: 0 }}>{option.email !== null && option.email !== undefined && option.email !== "" ? `${option.email.substring(0, 10)}...` : option.email}({option.type})</p> */}
              </div>
              <div className='div_last'>
                {bccSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      // const isValidEmail = /\S+@\S+\.\S+/.test(value);
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      // If valid email and not already in the filtered options, add it
      if (isValidEmail && !filteredOptions.some(option => option.data.email === value)) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setBccOptions(filteredOptions);
    } else {
      setBccOptions([]);
    }
  };
  const BcchandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(bccOptions[index].data);
    if (selectedItem) {
      const isSelected = bccSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setBccSelectedItems(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setBccData(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
      } else {
        const newSelectedItems = [...bccSelectedItems, selectedItem];
        setBccSelectedItems(newSelectedItems);
        setBccData(newSelectedItems);
      }
      setBccInputValue('');
      setBccOptions([]);
    }
  };
  const BcchandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setBccSelectedItems(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setBccData(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
  };
  const setBccClose = () => {
    setBccOpen(false)
    setBccInputValue('');
    setBccOptions([]);
    setBccData([])
    setBccSelectedItems([])
  }
  // const Action = (
  //   <div style={{
  //     padding: "0px 20px 0px 20px",
  //     width: "100%",
  //     height: "100%",
  //   }}>
  //     <div>
  //       <Checkbox
  //         checked
  //         disabled
  //       >
  //         Link this email to <b>Contacts/Leads</b> in the &quot;To&quot; field
  //       </Checkbox>
  //     </div>
  //     <div >
  //       <Checkbox
  //         checked={linkType.includes('Accounts')}
  //         onChange={(e) => handleCheckboxChange('Accounts', e.target.checked)}
  //       > Link this email to <b>Accounts</b> related to contacts in the &quot;To&quot; field
  //       </Checkbox>
  //     </div>
  //     <div >
  //       <Checkbox
  //         checked={linkType.includes('Deals')}
  //         onChange={(e) => handleCheckboxChange('Deals', e.target.checked)}
  //       > Link this email to <b>Deals</b> related to contacts in the &quot;To&quot; field
  //       </Checkbox>
  //     </div>
  //   </div>
  // )
  const downloadAttachment = (attachment) => {
    const blob = new Blob([new Uint8Array(attachment.content.data)], { type: attachment.contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = attachment.filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };
  const removeRow = async (index) => {
    const updatedFormData = [...files];
    updatedFormData.splice(index, 1);
    setFiles(updatedFormData);
  }
  const shortenFilename = (filename, maxLength = 20) => {
    const extension = filename.substring(filename.lastIndexOf('.'));
    const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
    if (nameWithoutExtension.length > maxLength) {
      return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
    }
    return filename;
  };
  useEffect(() => {
    if (mailOpen) {
      setParticipantData2([])
      setParticipantData([])
      getPartcipants()
    }
  }, [entityName, mailOpen])
  useEffect(() => {
    if (mailOpen) {
      if (replyToPopup === "DraftDetail") {
        if (forwardformat) {
          if (forwardformat?.to.length > 0) {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = toData.split(',').map(email => email.trim())
            const processedUsers = processEmails(emailArray);
            setState({ ...state, tags: processedUsers });
            setToSelectedItems(processedUsers)
          }
          else {
            setState({ ...state, tags: [] });
            setToSelectedItems([])
          }
          if (forwardformat?.cc.length > 0) {
            const ccData = forwardformat.cc?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = ccData.split(',').map(email => email.trim())
            const processedUsers = processEmails2(emailArray);
            setCcData(processedUsers);
            setCcSelectedItems(processedUsers)
          }
          else {
            setCcData([]);
            setCcSelectedItems([]);
          }
          if (forwardformat?.bcc.length > 0) {
            const bccData = forwardformat.bcc?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = bccData.split(',').map(email => email.trim())
            const processedUsers = processEmails2(emailArray);
            setBccData(processedUsers);
            setBccSelectedItems(processedUsers)
          }
          else {
            setBccData([]);
            setBccSelectedItems([]);
          }
        }
      }
      else if (replyToPopup === "Reply To") {
        if (forwardformat) {
          let replayids;
          if (detailsPage === 'INBOX' || detailsPage === 'Trash' || detailsPage === 'Spam') {
            const emailArray = forwardformat.from.address.split(',').map(email => email.trim())
            replayids = emailArray
          } else if (detailsPage === 'Sent' || detailsPage === 'BulkEMail') {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = toData.split(',').map(email => email.trim())
            replayids = emailArray;
          }
          const newUserList = replayids.map(replayid => {
            let userData = participantData.find(item => item.email === replayid);
            if (!userData) {
              userData = {
                id: "",
                name: replayid,
                type: "Others",
                email: replayid,
              };
            }
            else {
              userData = {
                id: userData.id,
                name: userData.name,
                type: userData.type,
                email: userData.email,
              };
            }
            return userData;
          });
          setState({ ...state, tags: newUserList })
          setToSelectedItems(newUserList)
        }
      }
      else if (replyToPopup === "Reply All") {
        if (forwardformat) {
          const loginEmail = emailapiValues.email?.toLowerCase();
          const replayids = [];
          const replayids1 = [];
          if (detailsPage === 'INBOX' || detailsPage === 'Spam') {
            replayids.push(
              ...forwardformat.from?.address
                ?.split(',')
                .map(e => e.trim()) || []
            );
          } else if (detailsPage === 'Sent' || detailsPage === "Bulk Email" || detailsPage === "Approval Email" || detailsPage === "Automation Email" || detailsPage === "Outreah") {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            replayids.push(...toData.split(',').map(e => e.trim()).filter(Boolean));
          }
          else if (detailsPage === 'Trash') {
            const fromEmail = forwardformat.from?.address?.toLowerCase();
            if (fromEmail === loginEmail) {
              const toData = forwardformat.to
                ?.map(item => item.address || item.email)
                .join(", ");
              replayids.push(...toData.split(',').map(e => e.trim()).filter(Boolean));
            } else {
              replayids.push(fromEmail);
            }
          }
          const ccData = forwardformat.cc?.map((item) => (item.address || item.email)).join(", ") || "";
          replayids1.push(...ccData.split(',').map(email => email.trim()).filter(Boolean));
          if (replayids?.length > 0) {
            const uniqueReplayIds = [
              ...new Set(
                replayids.filter(
                  email => email && email.toLowerCase() !== loginEmail
                )
              )
            ];
            const newUserList = uniqueReplayIds.map(replayid => {
              let userData = participantData.find(item => item.email === replayid);
              if (!userData) {
                userData = {
                  id: "",
                  name: replayid,
                  type: "Others",
                  email: replayid,
                };
              }
              else {
                userData = {
                  id: userData.id,
                  name: userData.name,
                  type: userData.type,
                  email: userData.email,
                };
              }
              return userData;
            });
            setState({ ...state, tags: newUserList })
            setToSelectedItems(newUserList)
          } else {
            setState({ ...state, tags: [] });
            setToSelectedItems([])
          }
          if (replayids1?.length > 0) {
            const uniqueReplayIds = [
              ...new Set(
                replayids1.filter(
                  email => email && email.toLowerCase() !== loginEmail
                )
              )
            ];
            const newUserList = uniqueReplayIds.map(replayid => {
              let userData = participantData.find(item => item.email === replayid);
              if (!userData) {
                userData = {
                  id: "",
                  name: replayid,
                  type: "Others",
                  email: replayid,
                };
              }
              else {
                userData = {
                  id: userData.id,
                  name: userData.name,
                  type: userData.type,
                  email: userData.email,
                };
              }
              return userData;
            });
            setCcData(newUserList);
            setCcSelectedItems(newUserList)
            setCcOpen(true)
          }
          else {
            setCcOpen(false)
            setCcData([]);
            setCcSelectedItems([]);
          }
        }
      }
      else {
        // eslint-disable-next-line no-lonely-if
        if (participantData.length > 0 && toId) {
          const processedUsers = Emailsarray(toId);
          setState({ ...state, tags: processedUsers });
          setToSelectedItems(processedUsers)
        }
      }
    }
  }, [replyToPopup, forwardformat, participantData, toId, participantData2, mailOpen])
  useEffect(() => {
    if (toSelectedItems.length > 0) {
      setEntityId(toSelectedItems[0].id)
    } else {
      setEntityId()
    }
  }, [toSelectedItems])
  const showConfirm = (id) => {
    const hasSubject = subject !== undefined && subject !== null && subject !== "";
    const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
    let title;
    let content;
    let okText;
    let cancelText;
    let showCancel;
    let onOkHandler;
    let onCancelHandler;
    if (!hasRecipients) {
      // Case 2: No recipients
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>No Recipients</span>
        </div>
      );
      content = <p>Please add at least one recipient before sending this message.</p>;
      okText = "OK";
      cancelText = null;
      showCancel = false;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = null;
    }
    else if (!hasSubject) {
      // Case 1: Missing subject
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>Missing subject</span>
        </div>
      );
      content = <p>Do you want to send this message without a subject?</p>;
      okText = "Don't send";
      cancelText = "Send";
      showCancel = true;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = () => onEmailSend(id);
    }
    else {
      // Default case (safe fallback)
      return onEmailSend(id);
    }
    const modalInstance = Modal.confirm({
      title,
      icon: null,
      className: "customice-confirm-modal",
      content,
      centered: true,
      okText,
      cancelText,
      okButtonProps: { className: "gray-buttonModal" },
      cancelButtonProps: { className: "button_colorsModal" },
      okCancel: showCancel,
      onOk: () => onOkHandler(modalInstance),
      onCancel: onCancelHandler,
    });
  };
  const showConfirm1 = (id, value) => {
    const hasSubject = subject !== undefined && subject !== null && subject !== "";
    const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
    let title;
    let content;
    let okText;
    let cancelText;
    let showCancel;
    let onOkHandler;
    let onCancelHandler;
    if (!hasRecipients) {
      // Case 2: No recipients
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>No Recipients</span>
        </div>
      );
      content = <p>Please add at least one recipient before saving this message.</p>;
      okText = "OK";
      cancelText = null;
      showCancel = false;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = null;
    }
    else if (!hasSubject) {
      // Case 1: Missing subject
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>Missing subject</span>
        </div>
      );
      content = <p>Do you want to save this message without a subject?</p>;
      okText = "Cancel";
      cancelText = "Save";
      showCancel = true;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = () => onDraftSend(id, value);
    }
    else {
      // Default case (safe fallback)
      return onDraftSend(id, value);
    }
    const modalInstance = Modal.confirm({
      title,
      icon: null,
      className: "customice-confirm-modal",
      content,
      centered: true,
      okText,
      cancelText,
      okButtonProps: { className: "gray-buttonModal" },
      cancelButtonProps: { className: "button_colorsModal" },
      okCancel: showCancel,
      onOk: () => onOkHandler(modalInstance),
      onCancel: onCancelHandler,
    });
  };
  const SubjectNameCheck = (id) => {
    if (subject !== undefined && subject !== null && subject !== "" && toSelectedItems?.length) {
      // Check if AI content exists and hasn't been inserted
      if (aiContent && aiCompose) {
        setShowAiDraftConfirm(true);
      } else {
        onEmailSend(id);
      }
    } else {
      showConfirm(id)
    }
  }
  const SubjectNameCheck1 = (id, value) => {
    if (subject !== undefined && subject !== null && subject !== "" && toSelectedItems?.length) {
      onDraftSend(id, value)
    } else {
      showConfirm1(id, value)
    }
  }
  async function AiDraftCall() {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick2(true)
    try {
      const DraftSubject = subject;
      const Draftcontent = content;
      const payload = {
        tone: "Professional",
        subject: DraftSubject,
        context: Draftcontent,
        toAddress: state.tags,
        signature: `<div id="signature-block-unique" contenteditable="true" style="margin-top: 20px;">
    ${profile?.profileSignature || "<div>Add signature</div>"}
  </div>`,
      }
      const response = await AIDefatMessage(companyProfile.companyId, payload)
      const rawContent = response?.choices?.[0]?.message?.content || "";
      // const match = rawContent.match(/```html([\s\S]*?)```/);
      const match = rawContent.match(/```html([\s\S]*?)(```|$)/);
      const htmlContent = match ? match[1].trim() : rawContent.trim();
      setAiContent(htmlContent)
      loadingRef.current = false;
      setDoubleClick2(false)
    }
    catch (error) {
      loadingRef.current = false;
      setDoubleClick2(false)
      setAiContent("");
      message.error(error)
    }
  }
  const AiContentCall = () => {
    setAiContent()
    setAiCompose(true)
    toggleSize(1200)
    AiDraftCall()
  }
  const onAiclose = () => {
    setAiContent()
    setAiCompose(false)
    toggleSize(600)
  }
  const MergeAiContent = () => {
    if (!aiContent) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(content || "<div></div>", "text/html");
    const nonEditable = doc.querySelector("div[contenteditable='false']");
    if (nonEditable) {
      let node = doc.body.firstChild;
      while (node && node !== nonEditable) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      nonEditable.insertAdjacentHTML("beforebegin", aiContent);
      setContent(doc.body.innerHTML);
    } else {
      setContent(aiContent)
    }
    onAiclose();
  };

  const handleAiDraftConfirm = () => {
    setShowAiDraftConfirm(false);
    setAiContent();
    setAiCompose(false);
    toggleSize(600);
    onEmailSend(mailSaveId);
  };

  const handleAiDraftCancel = () => {
    setShowAiDraftConfirm(false);
  };

  const handleAddSignature = () => {
    setContent((prevContent) => {
      const identifier = "signature-block-unique";

      const signatureHtml = `<div id="${identifier}">
      ${profile?.profileSignature || "<div>Add signature</div>"}
    </div>`;
      const spacerDivs = `<div>&nbsp;</div><div>&nbsp;</div>`;

      // Check if signature already exists
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = prevContent;
      const existingSignature = tempDiv.querySelector(`#${identifier}`);

      if (existingSignature) {
        // Replace existing signature
        existingSignature.outerHTML = signatureHtml;
        return tempDiv.innerHTML;
      }
      const replyBlock = tempDiv.querySelector("#ReplyContent");
      const forwardBlock = tempDiv.querySelector("#ForwardContent");

      if (replyBlock || forwardBlock) {
        // Determine target block to insert before
        const targetBlock = replyBlock || forwardBlock;

        // Insert signature before the reply/forward section
        const wrapper = document.createElement('div');
        wrapper.innerHTML = `${spacerDivs}${signatureHtml}`;
        targetBlock.parentNode.insertBefore(wrapper, targetBlock);

        return tempDiv.innerHTML;
      }
      const contentToAdd = prevContent.trim() === ""
        ? prevContent.trim() + spacerDivs
        : prevContent.trim();
      // Add new signature
      return `${contentToAdd.trim()}${signatureHtml}`;
    });
  };

  return (
    <>
      <Drawer
        className='Drawer-Header-Pages'
        bodyStyle={{ padding: 0 }}
        closable={false}
        placement="right"
        width={composeSize}
        open={mailOpen}
        title="Email"
        extra={
          <Space>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              {!aiCompose ?
                (composeSize === 600 ?
                  <FeatherIcon onClick={() => toggleSize(1200)} icon="maximize-2" size={20} style={{ cursor: "pointer" }} /> :
                  <FeatherIcon onClick={() => toggleSize(600)} icon="minimize-2" size={20} style={{ cursor: "pointer" }} />) : ""}
              <FeatherIcon onClick={() => onclose(mailSaveId, "Close")} icon="x" size={20} style={{ cursor: "pointer" }} />
            </div>
          </Space >
        }
        footer={[
          <div style={{ display: "flex", alignItems: 'center', justifyContent: "space-between" }}>
            <div className="form_action_button">
              <Button size="small" raised className="gradient-button" onClick={() => AiContentCall()}
                disabled={disabled || doubleClick2 || (subject === undefined || subject === null || subject === "") || (content === undefined || content === null || content === "")} loading={doubleClick2}>
                {!doubleClick2 && <AiIcon />}Generate Draft
              </Button>
            </div>
            <div className="form_action_button">
              <Button size="small" onClick={() => onclose(mailSaveId, "DraftMail")} raised className="gray-button" disabled={disabled}>
                <FeatherIcon icon="trash-2" />Discard
              </Button>
              <Button size="small" onClick={() => SubjectNameCheck1(mailSaveId, "Save")} raised className="button_colors" disabled={disabled || doubleClick1} loading={doubleClick1}>
                {!doubleClick1 && <FeatherIcon icon="save" />}Save
              </Button>
              <Button size="small" onClick={() => SubjectNameCheck(mailSaveId)} raised className="button_colors" disabled={disabled || doubleClick} loading={doubleClick}>
                {!doubleClick && <FeatherIcon icon="send" />}Send
              </Button>
            </div>
          </div>
        ]}
      >
        <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
          <div style={{ margin: "20px 40px" }}>
            <MailBox2>
              <div className="body email-body" style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: aiCompose ? "50%" : "100%" }}>
                  {(typeOfPge === "DraftDetail" &&
                    !forwardformat) ?
                    <div className="spin">
                      <Spin />
                    </div> :
                    <div className="body">
                      <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div className="reply-inner">
                            {toSelectedItems.length > 0 && toSelectedItems[0] &&
                              <div className='Div_flex'>
                                {toSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                    {/* {templateId ? <></> : <> */}
                                    {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => TohandleDeselect(item)} />}
                                    {/* </>} */}
                                  </div>
                                ))}
                              </div>}
                            {/* {templateId ? <></> : */}
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              <AutoComplete
                                style={{ width: "100%", maxWidth: CcOpen || BccOpen ? "100%" : "90%" }}
                                onSearch={TohandleSearch}
                                onSelect={TohandleSelect}
                                options={toOptions}
                                value={toInputValue}
                                onChange={setToInputValue}
                              >
                                <Input placeholder={replyToPopup === "Reply To" ? "To" : 'To'} />
                              </AutoComplete>
                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {CcOpen || BccOpen ? <></> :
                                  <><span className="Email-CcBcc" role="button"
                                    tabIndex={0}
                                    onClick={handleCcOpen}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        handleCcOpen()
                                      }
                                    }}>Cc</span>
                                    <span className="Email-CcBcc" role="button"
                                      tabIndex={0}
                                      onClick={handleBccOpen}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                          handleBccOpen()
                                        }
                                      }}>Bcc</span>
                                  </>
                                }
                              </div>
                            </TopToolBoxClone3>
                            {/* } */}
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>
                      {CcOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div className="reply-inner">
                            {ccSelectedItems.length > 0 &&
                              <div className='Div_flex'>
                                {ccSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                    {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => CchandleDeselect(item)} />}
                                  </div>
                                ))}
                              </div>
                            }
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              <AutoComplete
                                style={{ width: "90%" }}
                                onSearch={CchandleSearch}
                                onSelect={CchandleSelect}
                                options={ccOptions}
                                value={ccInputValue}
                                onChange={setCcInputValue}
                              >
                                <Input placeholder='Cc' />
                              </AutoComplete>
                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {BccOpen ? <></> : <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={handleBccOpen}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      handleBccOpen()
                                    }
                                  }}>Bcc</span>}
                                <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={() => setCcClose()}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      setCcClose()
                                    }
                                  }}><s>Cc</s></span>
                              </div>
                            </TopToolBoxClone3>
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      {BccOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div className="reply-inner">
                            {bccSelectedItems.length > 0 &&
                              <div className='Div_flex'>
                                {bccSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                    {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => BcchandleDeselect(item)} />}
                                  </div>
                                ))}
                              </div>
                            }
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              <AutoComplete
                                style={{ width: "90%" }}
                                onSearch={BcchandleSearch}
                                onSelect={BcchandleSelect}
                                options={bccOptions}
                                value={bccInputValue}
                                onChange={setBccInputValue}
                              >
                                <Input placeholder='Bcc' />
                              </AutoComplete>

                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {CcOpen ? <></> : <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={handleCcOpen}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      handleCcOpen()
                                    }
                                  }}>Cc</span>
                                }
                                <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={() => setBccClose()}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      setBccClose()
                                    }
                                  }}><s>Bcc</s></span>
                              </div>
                            </TopToolBoxClone3>
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      {/* <div className="group">
                <Input placeholder="Reply To" type="text" value={replayTo} onChange={(e) => setReplayTo(e.target.value)} />
              </div> */}
                      <div className="group">
                        <Input placeholder="Subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
                      </div>
                      <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }}>
                        {(entity !== "MailPage" && entity === "EntityPages" && toSelectedItems.length === 1) &&
                          <div className="text_icon" role="button" style={{ cursor: "pointer" }}
                            tabIndex={0}
                            onClick={OpenTemplates}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                OpenTemplates()
                              }
                            }}>
                            <InsertTempIcon marginRight={5} width={14} height={14} /><span className="text_iconspace">Insert Template</span><DownOutlined style={{ fontSize: '12px' }} />
                          </div>
                        }
                        <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }}>
                          <Buttons
                            type="text"
                            onClick={handleAddSignature}
                            className='signature-Button'
                          >
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FeatherIcon icon="plus-circle" className="text_iconspace" size={15} /> Add signature</span>
                          </Buttons>
                        </div>
                        {/* <div style={{ cursor: "pointer" }}>
                    <Popover
                      placement="bottomLeft"
                      content={Action}
                      trigger="hover"
                      open={openQuery}
                      onOpenChange={handleOpenQureyChange}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <LinkEmailIcon marginRight={5} width={16} height={16} marginBottom={2} /><span className="text_iconspace">Link Email</span><DownOutlined style={{ fontSize: '12px' }} />
                      </div>
                    </Popover>
                  </div> */}
                      </div>
                      <div className="group">
                        <TinyMCEEditor placeholder="Compose email..." setContent={setContent} content={content} edit={edit} page="Email" setFiles={setFiles} height={400} selectedEntity="A" />
                      </div>
                      <div className="group" style={{ marginTop: "20px", display: "flex", gap: 10 }}>
                        {files.map((file, index) => (
                          <figure key={index} style={{ display: "flex", gap: 10 }}>
                            <div className="attachment-image">
                              <img style={{ height: "40px" }}
                                src={require('../../../static/img/defaultImages/justify.png')}
                                alt={file.filename}
                              />
                            </div>
                            <figcaption style={{ flex: 1, marginTop: 0 }}>
                              <div title={file.filename} style={{
                                cursor: "default",
                                fontWeight: 700,
                                fontSize: 12,
                              }}>{shortenFilename(file.filename, 20)}</div>
                              <div style={{
                                display: "flex", alignItems: "center", justifyContent: "flex-start",
                                gap: '10px',
                                marginTop: '5px',
                              }}>
                                <span style={{
                                  fontSize: 10,
                                  fontWeight: 600,
                                  color: "#4183f1",
                                  cursor: "pointer",
                                  flexGrow: 0,
                                }} role="button" tabIndex={0}
                                  onClick={() => downloadAttachment(file)}
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                      downloadAttachment(file)
                                    }
                                  }}> Download
                                </span>
                                <span style={{
                                  fontSize: 10,
                                  fontWeight: 600,
                                  color: "red",
                                  cursor: "pointer",
                                  flexGrow: 0,
                                }}>
                                  <FeatherIcon icon="trash-2" size={10} style={{ marginTop: 2 }} onClick={() => removeRow(index)} />
                                </span>
                              </div>
                            </figcaption>
                          </figure>
                        ))}
                      </div>
                    </div>}
                </div>
                {aiCompose ?
                  <div style={{
                    width: "50%", marginLeft: 15,
                    borderLeft: "1px solid #eee",
                    padding: "15px 20px 20px"
                  }} >
                    <div className="body">
                      {/* <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div className="reply-inner">
                            {toSelectedItems.length > 0 && toSelectedItems[0] &&
                              <div className='Div_flex'>
                                {toSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                  </div>
                                ))}
                              </div>}
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>
                      {CcOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div className="reply-inner">
                            {ccSelectedItems.length > 0 &&
                              <div className='Div_flex'>
                                {ccSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                  </div>
                                ))}
                              </div>
                            }
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      {BccOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div className="reply-inner">
                            {bccSelectedItems.length > 0 &&
                              <div className='Div_flex'>
                                {bccSelectedItems.map((item, index) => (
                                  <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                    <span className={`image_icon ${item.type === "Leads" ? "LeadIcon"
                                      : item.type === "User" ? "UserIcon"
                                        : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                      {item.name.slice(0, 1).toUpperCase()}
                                    </span>
                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                  </div>
                                ))}
                              </div>
                            }
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      <div className="group">
                        <div style={{ padding: "15px 0px 5px" }}> Subject: {subject}</div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div> */}
                      {/* <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }} /> */}
                      <div className="group">
                        <div style={{
                          fontSize: "larger",
                          padding: "0px 0px 10px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#6a5af9"
                        }}> AI Assisted Draft</div>
                      </div>
                      <div className="group" style={{
                        border: "2px solid #eee",
                        padding: aiContent ? "20px 0px 20px 20px" : "0px",
                        borderRadius: "10px",
                        height: "500px"
                      }}>
                        {aiContent ? <CustomHtmlParser html={aiContent} key={1} page="Previews" /> :
                          <div className="spin" style={{ height: "500px" }}>
                            <Spin />
                          </div>}
                      </div>
                    </div>
                    <div style={{ marginTop: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <Button size="small" className="button_colors" onClick={() => MergeAiContent()} disabled={!aiContent}>
                        <FeatherIcon icon="arrow-left-circle" />  Insert Draft
                      </Button>
                      <Button size="small" onClick={() => onAiclose()} className="gray-button" disabled={disabled}>
                        <FeatherIcon icon="x" />Close
                      </Button>
                    </div>
                  </div> : ""}
              </div>
            </MailBox2 >
          </div >
        </Scrollbars >
      </Drawer >
      {openTemplate && <TemplateSelect openTemplate={openTemplate} setOpenTemplate={setOpenTemplate} setTemplateId={setTemplateId} entityName={entityName} />}
      {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={page} onDraftSend={onclose2} onDeleteSend={onDeleteSend} templateIDSS={templateID}
        OnCancel={OnCancel}
      />}
      <AiDraftConfirmPopup
        open={showAiDraftConfirm}
        onCancel={handleAiDraftCancel}
        onConfirm={handleAiDraftConfirm}
      />
    </>
  );
}

Compose.propTypes = {
  close: propTypes.func,
  entity: propTypes.string,
  entityName: propTypes.string,
  // dbMailId: propTypes.number,
  toId: propTypes.string,
  SendFunction: propTypes.func,
  // setDbMailId: propTypes.func,
  DraftFunction: propTypes.func,
  setDetailsData: propTypes.func,
  mailOpen: propTypes.bool,
  // TrashFunction: propTypes.func,
  replyToPopup: propTypes.string,
  forwardformatss: propTypes.object,
  // MovetoTrash: propTypes.func,
  templateIDSS: propTypes.number,
  AccountId: propTypes.number,
  detailsPage: propTypes.string,
  CallBackTrigger: propTypes.func,
  DeleteDraftForever: propTypes.func,
  setTemplateIDSS: propTypes.func,
  isCancel: propTypes.string,
  searchText: propTypes.string,
  Comefrom: propTypes.string,
  setNaCTrigger: propTypes.func,
  entityUId: propTypes.number
};

Compose.defaultProps = {
  close: () => { },
};

export default Compose;
